import { Button } from "@mui/material";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import SearchControllsProps from "../interface/searchControllsProps";

const StartSearchButton = (): React.JSX.Element => {
  const {
    searchControlls,
    fetchAppointments,
  }: {
    searchControlls: SearchControllsProps;
    fetchAppointments: () => void;
  } = React.useContext(AppointmentOverviewContext);

  return (
    <Button
      disabled={searchControlls.loading}
      onClick={fetchAppointments}
      size="large"
      sx={{
        height: "100%",
      }}
      fullWidth
      variant="contained"
      color="primary"
    >
      Suchen
    </Button>
  );
};

export default StartSearchButton;
